<template>
  <nav class="user-mobile-nav" aria-label="手机端主导航">
    <router-link class="user-mobile-nav__item" to="/servers" exact>
      <i class="el-icon-s-grid" />
      <span>服务器</span>
    </router-link>

    <router-link
      class="user-mobile-nav__item user-mobile-nav__item--primary"
      :class="{ 'is-active': Boolean(currentServerCode) }"
      :to="shopTarget"
      :title="hasShopTarget ? '返回当前服务器商城' : '请先选择服务器'"
    >
      <span class="user-mobile-nav__primary-icon"><i class="el-icon-shopping-bag-2" /></span>
      <span>补给站</span>
    </router-link>

    <router-link class="user-mobile-nav__item" to="/profile">
      <i class="el-icon-user" />
      <span>我的</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'UserMobileNav',
  computed: {
    currentServerCode () {
      return this.$route.params && this.$route.params.serverCode
        ? String(this.$route.params.serverCode)
        : ''
    },
    savedServerCode () {
      try {
        return localStorage.getItem('DAYZ_LAST_SERVER') || ''
      } catch (e) {
        return ''
      }
    },
    hasShopTarget () {
      return Boolean(this.currentServerCode || this.savedServerCode)
    },
    shopTarget () {
      const serverCode = this.currentServerCode || this.savedServerCode
      return serverCode ? `/shop/${encodeURIComponent(serverCode)}` : '/servers'
    }
  },
  watch: {
    currentServerCode: {
      immediate: true,
      handler (serverCode) {
        if (!serverCode) return
        try {
          localStorage.setItem('DAYZ_LAST_SERVER', serverCode)
        } catch (e) {}
      }
    }
  }
}
</script>

<style scoped>
.user-mobile-nav {
  position: fixed;
  right: 10px;
  bottom: max(10px, env(safe-area-inset-bottom));
  left: 10px;
  z-index: 1200;
  display: none;
  min-height: 64px;
  grid-template-columns: repeat(3, 1fr);
  align-items: end;
  padding: 7px 10px 8px;
  border: 1px solid rgba(223, 218, 194, .18);
  border-radius: 14px;
  background: rgba(9, 12, 9, .94);
  box-shadow: 0 16px 44px rgba(0, 0, 0, .58), inset 0 1px rgba(255,255,255,.035);
  backdrop-filter: blur(18px) saturate(.86);
}

.user-mobile-nav__item {
  position: relative;
  min-width: 0;
  min-height: 48px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  color: #899188;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.user-mobile-nav__item > i { font-size: 20px; }
.user-mobile-nav__item.router-link-active { color: var(--dz-accent); }

.user-mobile-nav__item--primary { margin-top: -25px; }
.user-mobile-nav__item--primary.router-link-active { color: #899188; }
.user-mobile-nav__item--primary.is-active { color: var(--dz-accent); }
.user-mobile-nav__primary-icon {
  width: 50px;
  height: 50px;
  display: grid;
  place-items: center;
  color: #11140d;
  border: 5px solid #0b0e0b;
  border-radius: 16px 5px 16px 5px;
  background: var(--dz-accent);
  box-shadow: 0 8px 22px rgba(0, 0, 0, .42);
}
.user-mobile-nav__primary-icon i { font-size: 21px; }

@media (max-width: 720px) {
  .user-mobile-nav { display: grid; }
}
</style>
